// extracted by mini-css-extract-plugin
module.exports = {"arrow":"index_arrow_3hwPt","el-upload--text":"index_el-upload--text_1yOQs"};